export const removeSecureDataFromUser = (authResponse: KIARA_API.AuthResponseDto) => authResponse.user;
